
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexVQal9C_45zgd_45gSCp5vpQcdKRalyIAQMpB1XQh5srWAU8Meta } from "/usr/src/app/app/pages/index.vue?macro=true";
import { default as _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta } from "/usr/src/app/app/pages/_health.vue?macro=true";
import { default as FaqsIoXytMA0e_45Cu3eDCYiuPX1a92aAByv8_45nyj5ouHm9ZIMeta } from "/usr/src/app/app/pages/[region]/Faqs.vue?macro=true";
import { default as PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta } from "/usr/src/app/app/pages/PlayersLegend.vue?macro=true";
import { default as StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta } from "/usr/src/app/app/pages/StoresLanding.vue?macro=true";
import { default as DraftfAyMyiNV13Wm8A9rnYSgIMGrMJshkWsw0ws_45eZo1ToEMeta } from "/usr/src/app/app/pages/[region]/Draft.vue?macro=true";
import { default as indexY0Q4baHhsn_UdPikei_Owtt3dJEeoUYvzRtuAayhJ8oMeta } from "/usr/src/app/app/pages/[region]/index.vue?macro=true";
import { default as TeamsalApWjPsDDXVvg4ZpStNVQaQcyEtMTqMHu0t4pTkjkYMeta } from "/usr/src/app/app/pages/[region]/Teams.vue?macro=true";
import { default as TablesZrZ0pW4qaEFDHcNailFFGMAALwMpD1E1SvYMZEzOlrYMeta } from "/usr/src/app/app/pages/[region]/Tables.vue?macro=true";
import { default as Matches4TpiufXK6IjK6hyD11DQv3_ROqBeNrP25iYolcj_SPUMeta } from "/usr/src/app/app/pages/[region]/Matches.vue?macro=true";
import { default as MercatoEB3iGpIVZb6E47hNUGR8MXHVWqTx6CX3_NTQhZuj1bAMeta } from "/usr/src/app/app/pages/[region]/Mercato.vue?macro=true";
import { default as TicketsGVnlEVyQiWZSZkyRjgC6b_ZVCnFf__45jTVtCqgBFQ3BkMeta } from "/usr/src/app/app/pages/[region]/Tickets.vue?macro=true";
import { default as TierListJguMWKgW2Fkv87IiVPK90pvpX1tx8YkaTTBYiyKdemYMeta } from "/usr/src/app/app/pages/[region]/TierList.vue?macro=true";
import { default as FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta } from "/usr/src/app/app/pages/FinalissimaQueens.vue?macro=true";
import { default as ContactUsq_45GfkuOkzHap_NGYIElN9_XhXmlgEsSMaeEEB7cmPFQMeta } from "/usr/src/app/app/pages/[region]/ContactUs.vue?macro=true";
import { default as MvpKasj_N0Yc6xiYbX96XFPa5SnSAEdLWyc4IcNdofzfDAMeta } from "/usr/src/app/app/pages/[region]/stats/Mvp.vue?macro=true";
import { default as RegulationWgFwmOvTXC2yC5COpy9ex4WOAkSYCKYbibHbgaXzrzQMeta } from "/usr/src/app/app/pages/[region]/Regulation.vue?macro=true";
import { default as TablesKwccg4GyRrpciM5Rj46yKDHtar9XHgyslsco7hHkgE_45b_RkMeta } from "/usr/src/app/app/pages/[region]/TablesKwcc.vue?macro=true";
import { default as TournamentLbLnk70W67fI2_cpJMs8ckvKTzzpTRuUG7rsUvl7mdQMeta } from "/usr/src/app/app/pages/[region]/Tournament.vue?macro=true";
import { default as CardsenuQ_45BaDtbVd9fJT2egL3oKF0yDZGLDnty_ST1cmUz8Meta } from "/usr/src/app/app/pages/[region]/stats/Cards.vue?macro=true";
import { default as Goalsr0HgFz_45_45lAfx7SCMFgBjP0kZKLtBpNqSBabafrM4jxoMeta } from "/usr/src/app/app/pages/[region]/stats/Goals.vue?macro=true";
import { default as indexsXMaBN8BaTaFUiwABbTH679ECi86tyMUutZ5ykAGhUEMeta } from "/usr/src/app/app/pages/[region]/stats/index.vue?macro=true";
import { default as ShotsU9nP1QP5Ypu20s0gtbM18dtyMXaDbucdrVec_45rqgT4cMeta } from "/usr/src/app/app/pages/[region]/stats/Shots.vue?macro=true";
import { default as indexZIxWKMqPuyfXYssiRIT61YRDGvOFJrfPcaMFXt6lqBQMeta } from "/usr/src/app/app/pages/[region]/[news]/index.vue?macro=true";
import { default as JoinTheDraftbWQI23TautzohW0Or6gE_eBVMJKhb3Bjqrz1q65ff1IMeta } from "/usr/src/app/app/pages/[region]/JoinTheDraft.vue?macro=true";
import { default as PlayersDraftbfDJnxKaaOYDnPZSV4SaBBDZHJYmtDV1NdR0i3vfN64Meta } from "/usr/src/app/app/pages/[region]/PlayersDraft.vue?macro=true";
import { default as _91post_937QffanjNKEHb4B5V0C76y5Q0sS5TKoZHHSs0pJsKOzEMeta } from "/usr/src/app/app/pages/[region]/[news]/[post].vue?macro=true";
import { default as DraftReservesQhejqXrrtVj5n92YwYQiDy3tEr_45WuiLQiGCDHipr8AYMeta } from "/usr/src/app/app/pages/[region]/DraftReserves.vue?macro=true";
import { default as PlayersLegendwOX2HfodWYjs51k4gqMJ1qkkqSZvEKaWG0Xh0Ag9XVwMeta } from "/usr/src/app/app/pages/[region]/PlayersLegend.vue?macro=true";
import { default as AssistsLDwXucPuy3LlaxUJMZ0tZOrmFAVUSqxsa6DpDSMbtHEMeta } from "/usr/src/app/app/pages/[region]/stats/Assists.vue?macro=true";
import { default as PassingIoZKGyLPj33jpYgFQp7ajmJLlUybCIKAfTajP9fNQWoMeta } from "/usr/src/app/app/pages/[region]/stats/Passing.vue?macro=true";
import { default as TurnMvpZS5_ObFcNT4OWpwuJAj_L5Ud5IcmENsthNgLRomBdKUMeta } from "/usr/src/app/app/pages/[region]/stats/TurnMvp.vue?macro=true";
import { default as TeamSimulatorrEGQySdh4wNGZXNnpNQNt0IKiTuQUc404g0HgMQfAfIMeta } from "/usr/src/app/app/pages/[region]/TeamSimulator.vue?macro=true";
import { default as SquadSimulatorxryukjMj4H_eWq1l0gDwT9EgwQgzI3yVr4Khb9PHc3gMeta } from "/usr/src/app/app/pages/[region]/SquadSimulator.vue?macro=true";
import { default as ExpectedWAY2kmZmQNXDpRd08yGxzmlHShpB2r8FMb53IyifDSkMeta } from "/usr/src/app/app/pages/[region]/stats/Expected.vue?macro=true";
import { default as _91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta } from "/usr/src/app/app/pages/teams/[team]-[teamName].vue?macro=true";
import { default as PlayersVariableZRMsHI6Ome9XOapC860XS4VrwDsm2W3SA91y74ALDDkMeta } from "/usr/src/app/app/pages/[region]/PlayersVariable.vue?macro=true";
import { default as Defensives3icVwiHTb_45LInmB7P17dE3acSvn_455lt6itqSJ4A4PsoMeta } from "/usr/src/app/app/pages/[region]/stats/Defensives.vue?macro=true";
import { default as Goalkeeper1Vy_lxQ_45pvUbjNHQWaN2GUxGtUPGcRFOxDcXSqeBA1cMeta } from "/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue?macro=true";
import { default as OffensiveslvqECLri5xJk0CU5tdhpWmc_452Ro5ULRp4Q_mlUSqSNIMeta } from "/usr/src/app/app/pages/[region]/stats/Offensives.vue?macro=true";
import { default as CardsOKyyjyENBvYzzDMUJZ8nUxCiEUA44hJQ4tj3_45ckZMusMeta } from "/usr/src/app/app/pages/[region]/stats/teams/Cards.vue?macro=true";
import { default as indexFNJrEVyPOzcgdg0SagD1BDPEzul8ALlRlrkFuXpbKgYMeta } from "/usr/src/app/app/pages/[region]/stats/teams/index.vue?macro=true";
import { default as Shots0hc1vfIAOaWz8PkM0d90I_45C_45k5G5rMQvQhZy2UYAn6IMeta } from "/usr/src/app/app/pages/[region]/stats/teams/Shots.vue?macro=true";
import { default as GoalsGrouped_5jjDTveHrNG_1ztwAo2taH5dUzii90rMqIbOW8sHJcMeta } from "/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue?macro=true";
import { default as PassingvwlMdKYCjTDCqWiGxjAUskQxveD2nNngUDiPQOoZAc8Meta } from "/usr/src/app/app/pages/[region]/stats/teams/Passing.vue?macro=true";
import { default as BestGoalkeeper9pNon_BFkBwEzqTfcDieSWK4tVB_NVyjYd5xgP1qHwkMeta } from "/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue?macro=true";
import { default as Expectedp6Rr_45k603G01cQ8eAg_45tQo5gMHW8dxMwVBHxEEzNGAsMeta } from "/usr/src/app/app/pages/[region]/stats/teams/Expected.vue?macro=true";
import { default as CircularsEsy9BMTJWXUb3MNtLIYBJpFYozGzr_45rTPYxcDcnyr0KNkMeta } from "/usr/src/app/app/pages/[region]/circulars/CircularsEs.vue?macro=true";
import { default as CircularsItD1oBdO_45TglIc_45penXTyJ6zy4M52c8pxPbj3Pli_TeTYMeta } from "/usr/src/app/app/pages/[region]/circulars/CircularsIt.vue?macro=true";
import { default as MediaAccreditationInfoK_45RU1Ik_3zt87IUzzeAlTLEVFmgNgVyUyIRqD9xaq3AMeta } from "/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue?macro=true";
import { default as Defensivesf5hT3us_45mR10ej3y0np14iYOluIEYVRza0FLoel7uFUMeta } from "/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue?macro=true";
import { default as OffensivesZ2ljdWa0v8TdRwwZmYDsVSO1jMA_45RmxukohfLxMtylwMeta } from "/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue?macro=true";
import { default as _91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta } from "/usr/src/app/app/pages/players/[playerId]-[playerName].vue?macro=true";
import { default as _91team_93_45_91teamName_93ZcYJ0xljbzzrLr_4593JXuGJn2jN4L3iguOuXjgr6gWo8Meta } from "/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue?macro=true";
import { default as GoalsGrouped6GbkH0YVUM3YDM_45_l15RhU3Nc93rmOQSGvfHC0rl73YMeta } from "/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue?macro=true";
import { default as KokQualifiersSpainglbMI7cSam1Lh_AJr0OpjLZWcDUgWkZf50rVTjgTBOQMeta } from "/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue?macro=true";
import { default as _91playerId_93_45_91playerName_93tq98S7iGkLY0HwbE1Y3hDXb_0fRE0_45gj6PBbgb2cF9EMeta } from "/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue?macro=true";
import { default as KokQualifiersAmericas5khbWthD1qvxL5iZFszSpBX0R1rYXV3od_45LOOkrOQb4Meta } from "/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue?macro=true";
import { default as _91matchId_93_45_91homeTeam_93_45vs_45_91awayTeam_93cqXNWqzREVODyuseKL3NbuvtbSPX7VLOiD_45_G8GfwN8Meta } from "/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/ar",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    component: () => import("/usr/src/app/app/pages/index.vue")
  },
  {
    name: "_health___ar",
    path: "/ar/_health",
    meta: _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta || {},
    component: () => import("/usr/src/app/app/pages/_health.vue")
  },
  {
    name: "_health___de",
    path: "/de/_health",
    meta: _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta || {},
    component: () => import("/usr/src/app/app/pages/_health.vue")
  },
  {
    name: "_health___en",
    path: "/en/_health",
    meta: _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta || {},
    component: () => import("/usr/src/app/app/pages/_health.vue")
  },
  {
    name: "_health___es",
    path: "/es/_health",
    meta: _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta || {},
    component: () => import("/usr/src/app/app/pages/_health.vue")
  },
  {
    name: "_health___fr",
    path: "/fr/_health",
    meta: _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta || {},
    component: () => import("/usr/src/app/app/pages/_health.vue")
  },
  {
    name: "_health___it",
    path: "/it/_health",
    meta: _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta || {},
    component: () => import("/usr/src/app/app/pages/_health.vue")
  },
  {
    name: "_health___pt",
    path: "/pt/_health",
    meta: _healthYCg7GKigmlUY90kt35eYQS2LfL7EslijDnSjIxioWTEMeta || {},
    component: () => import("/usr/src/app/app/pages/_health.vue")
  },
  {
    name: "region-Faqs___ar",
    path: "/ar/:region()/faqs",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Faqs.vue")
  },
  {
    name: "region-Faqs___de",
    path: "/de/:region()/faqs",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Faqs.vue")
  },
  {
    name: "region-Faqs___en",
    path: "/en/:region()/faqs",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Faqs.vue")
  },
  {
    name: "region-Faqs___es",
    path: "/es/:region()/faqs",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Faqs.vue")
  },
  {
    name: "region-Faqs___fr",
    path: "/fr/:region()/faqs",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Faqs.vue")
  },
  {
    name: "region-Faqs___it",
    path: "/it/:region()/faqs",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Faqs.vue")
  },
  {
    name: "region-Faqs___pt",
    path: "/pt/:region()/faqs",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Faqs.vue")
  },
  {
    name: "PlayersLegend___ar",
    path: "/ar/legends",
    meta: { ...(PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/PlayersLegend.vue")
  },
  {
    name: "PlayersLegend___de",
    path: "/de/legenden",
    meta: { ...(PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/PlayersLegend.vue")
  },
  {
    name: "PlayersLegend___en",
    path: "/en/legends",
    meta: { ...(PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/PlayersLegend.vue")
  },
  {
    name: "PlayersLegend___es",
    path: "/es/leyendas",
    meta: { ...(PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/PlayersLegend.vue")
  },
  {
    name: "PlayersLegend___fr",
    path: "/fr/legendes",
    meta: { ...(PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/PlayersLegend.vue")
  },
  {
    name: "PlayersLegend___it",
    path: "/it/leggende",
    meta: { ...(PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/PlayersLegend.vue")
  },
  {
    name: "PlayersLegend___pt",
    path: "/pt/lendas",
    meta: { ...(PlayersLegendBIqufMnSFzA03zp17D4rrEYTCeJVAa3cN4K_45nCsjaNYMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/PlayersLegend.vue")
  },
  {
    name: "StoresLanding___ar",
    path: "/ar/stores",
    meta: { ...(StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/StoresLanding.vue")
  },
  {
    name: "StoresLanding___de",
    path: "/de/shops",
    meta: { ...(StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/StoresLanding.vue")
  },
  {
    name: "StoresLanding___en",
    path: "/en/stores",
    meta: { ...(StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/StoresLanding.vue")
  },
  {
    name: "StoresLanding___es",
    path: "/es/tiendas",
    meta: { ...(StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/StoresLanding.vue")
  },
  {
    name: "StoresLanding___fr",
    path: "/fr/boutiques",
    meta: { ...(StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/StoresLanding.vue")
  },
  {
    name: "StoresLanding___it",
    path: "/it/negozios",
    meta: { ...(StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/StoresLanding.vue")
  },
  {
    name: "StoresLanding___pt",
    path: "/pt/lojas",
    meta: { ...(StoresLandingZ8c0xNssm3Xg9BigmDAiGL8XEBlzIWf7Fd6eOFqiK7cMeta || {}), ...{"middleware":["not-found-queens"]} },
    component: () => import("/usr/src/app/app/pages/StoresLanding.vue")
  },
  {
    name: "region-Draft___ar",
    path: "/ar/:region()/draft",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Draft.vue")
  },
  {
    name: "region-Draft___de",
    path: "/de/:region()/draft",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Draft.vue")
  },
  {
    name: "region-Draft___en",
    path: "/en/:region()/draft",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Draft.vue")
  },
  {
    name: "region-Draft___es",
    path: "/es/:region()/draft",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Draft.vue")
  },
  {
    name: "region-Draft___fr",
    path: "/fr/:region()/draft",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Draft.vue")
  },
  {
    name: "region-Draft___it",
    path: "/it/:region()/draft",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Draft.vue")
  },
  {
    name: "region-Draft___pt",
    path: "/pt/:region()/draft",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Draft.vue")
  },
  {
    name: "region___ar",
    path: "/ar/:region()",
    component: () => import("/usr/src/app/app/pages/[region]/index.vue")
  },
  {
    name: "region___de",
    path: "/de/:region()",
    component: () => import("/usr/src/app/app/pages/[region]/index.vue")
  },
  {
    name: "region___en",
    path: "/en/:region()",
    component: () => import("/usr/src/app/app/pages/[region]/index.vue")
  },
  {
    name: "region___es",
    path: "/es/:region()",
    component: () => import("/usr/src/app/app/pages/[region]/index.vue")
  },
  {
    name: "region___fr",
    path: "/fr/:region()",
    component: () => import("/usr/src/app/app/pages/[region]/index.vue")
  },
  {
    name: "region___it",
    path: "/it/:region()",
    component: () => import("/usr/src/app/app/pages/[region]/index.vue")
  },
  {
    name: "region___pt",
    path: "/pt/:region()",
    component: () => import("/usr/src/app/app/pages/[region]/index.vue")
  },
  {
    name: "region-Teams___ar",
    path: "/ar/:region()/teams",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Teams.vue")
  },
  {
    name: "region-Teams___de",
    path: "/de/:region()/mannschaften",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Teams.vue")
  },
  {
    name: "region-Teams___en",
    path: "/en/:region()/teams",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Teams.vue")
  },
  {
    name: "region-Teams___es",
    path: "/es/:region()/equipos",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Teams.vue")
  },
  {
    name: "region-Teams___fr",
    path: "/fr/:region()/equipes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Teams.vue")
  },
  {
    name: "region-Teams___it",
    path: "/it/:region()/squadre",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Teams.vue")
  },
  {
    name: "region-Teams___pt",
    path: "/pt/:region()/times",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Teams.vue")
  },
  {
    name: "region-Tables___ar",
    path: "/ar/:region()/tables",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tables.vue")
  },
  {
    name: "region-Tables___de",
    path: "/de/:region()/klassifikation",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tables.vue")
  },
  {
    name: "region-Tables___en",
    path: "/en/:region()/tables",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tables.vue")
  },
  {
    name: "region-Tables___es",
    path: "/es/:region()/clasificacion",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tables.vue")
  },
  {
    name: "region-Tables___fr",
    path: "/fr/:region()/classement",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tables.vue")
  },
  {
    name: "region-Tables___it",
    path: "/it/:region()/classifica",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tables.vue")
  },
  {
    name: "region-Tables___pt",
    path: "/pt/:region()/classificacao",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tables.vue")
  },
  {
    name: "region-Matches___ar",
    path: "/ar/:region()/matches",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Matches.vue")
  },
  {
    name: "region-Matches___de",
    path: "/de/:region()/spiele",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Matches.vue")
  },
  {
    name: "region-Matches___en",
    path: "/en/:region()/matches",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Matches.vue")
  },
  {
    name: "region-Matches___es",
    path: "/es/:region()/partidos",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Matches.vue")
  },
  {
    name: "region-Matches___fr",
    path: "/fr/:region()/matchs",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Matches.vue")
  },
  {
    name: "region-Matches___it",
    path: "/it/:region()/partite",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Matches.vue")
  },
  {
    name: "region-Matches___pt",
    path: "/pt/:region()/jogos",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Matches.vue")
  },
  {
    name: "region-Mercato___en",
    path: "/en/:region()/mercato-transfers",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-italy","not-found-americas","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Mercato.vue")
  },
  {
    name: "region-Mercato___es",
    path: "/es/:region()/mercato-fichajes",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-italy","not-found-americas","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Mercato.vue")
  },
  {
    name: "region-Tickets___ar",
    path: "/ar/:region()/tickets",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tickets.vue")
  },
  {
    name: "region-Tickets___de",
    path: "/de/:region()/tickets",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tickets.vue")
  },
  {
    name: "region-Tickets___en",
    path: "/en/:region()/tickets",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tickets.vue")
  },
  {
    name: "region-Tickets___es",
    path: "/es/:region()/entradas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tickets.vue")
  },
  {
    name: "region-Tickets___fr",
    path: "/fr/:region()/billetterie",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tickets.vue")
  },
  {
    name: "region-Tickets___it",
    path: "/it/:region()/biglietti",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tickets.vue")
  },
  {
    name: "region-Tickets___pt",
    path: "/pt/:region()/ingressos",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tickets.vue")
  },
  {
    name: "region-TierList___ar",
    path: "/ar/:region()/tier-list",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TierList.vue")
  },
  {
    name: "region-TierList___de",
    path: "/de/:region()/tier-list",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TierList.vue")
  },
  {
    name: "region-TierList___en",
    path: "/en/:region()/tier-list",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TierList.vue")
  },
  {
    name: "region-TierList___es",
    path: "/es/:region()/tier-list",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TierList.vue")
  },
  {
    name: "region-TierList___fr",
    path: "/fr/:region()/tier-list",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TierList.vue")
  },
  {
    name: "region-TierList___it",
    path: "/it/:region()/tier-list",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TierList.vue")
  },
  {
    name: "region-TierList___pt",
    path: "/pt/:region()/tier-list",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TierList.vue")
  },
  {
    name: "FinalissimaQueens___ar",
    path: "/ar/finalissima",
    meta: { ...(FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta || {}), ...{"middleware":["not-found-kings"]} },
    component: () => import("/usr/src/app/app/pages/FinalissimaQueens.vue")
  },
  {
    name: "FinalissimaQueens___de",
    path: "/de/finalissima",
    meta: { ...(FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta || {}), ...{"middleware":["not-found-kings"]} },
    component: () => import("/usr/src/app/app/pages/FinalissimaQueens.vue")
  },
  {
    name: "FinalissimaQueens___en",
    path: "/en/finalissima",
    meta: { ...(FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta || {}), ...{"middleware":["not-found-kings"]} },
    component: () => import("/usr/src/app/app/pages/FinalissimaQueens.vue")
  },
  {
    name: "FinalissimaQueens___es",
    path: "/es/finalissima",
    meta: { ...(FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta || {}), ...{"middleware":["not-found-kings"]} },
    component: () => import("/usr/src/app/app/pages/FinalissimaQueens.vue")
  },
  {
    name: "FinalissimaQueens___fr",
    path: "/fr/finalissima",
    meta: { ...(FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta || {}), ...{"middleware":["not-found-kings"]} },
    component: () => import("/usr/src/app/app/pages/FinalissimaQueens.vue")
  },
  {
    name: "FinalissimaQueens___it",
    path: "/it/finalissima",
    meta: { ...(FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta || {}), ...{"middleware":["not-found-kings"]} },
    component: () => import("/usr/src/app/app/pages/FinalissimaQueens.vue")
  },
  {
    name: "FinalissimaQueens___pt",
    path: "/pt/finalissima",
    meta: { ...(FinalissimaQueens1z2HOd0dXYknTYeWXKrI_456wr56iXrMNfNsEfqlrRnNwMeta || {}), ...{"middleware":["not-found-kings"]} },
    component: () => import("/usr/src/app/app/pages/FinalissimaQueens.vue")
  },
  {
    name: "region-ContactUs___ar",
    path: "/ar/:region()/contact-us",
    meta: {"middleware":["not-found-italy","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/ContactUs.vue")
  },
  {
    name: "region-ContactUs___de",
    path: "/de/:region()/kontakt",
    meta: {"middleware":["not-found-italy","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/ContactUs.vue")
  },
  {
    name: "region-ContactUs___en",
    path: "/en/:region()/contact-us",
    meta: {"middleware":["not-found-italy","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/ContactUs.vue")
  },
  {
    name: "region-ContactUs___es",
    path: "/es/:region()/contacto",
    meta: {"middleware":["not-found-italy","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/ContactUs.vue")
  },
  {
    name: "region-ContactUs___fr",
    path: "/fr/:region()/contacter",
    meta: {"middleware":["not-found-italy","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/ContactUs.vue")
  },
  {
    name: "region-ContactUs___it",
    path: "/it/:region()/contatti",
    meta: {"middleware":["not-found-italy","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/ContactUs.vue")
  },
  {
    name: "region-ContactUs___pt",
    path: "/pt/:region()/contato",
    meta: {"middleware":["not-found-italy","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/ContactUs.vue")
  },
  {
    name: "region-stats-Mvp___ar",
    path: "/ar/:region()/stats/mvp",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Mvp.vue")
  },
  {
    name: "region-stats-Mvp___de",
    path: "/de/:region()/statistiken/mvp",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Mvp.vue")
  },
  {
    name: "region-stats-Mvp___en",
    path: "/en/:region()/stats/mvp",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Mvp.vue")
  },
  {
    name: "region-stats-Mvp___es",
    path: "/es/:region()/estadisticas/mvp",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Mvp.vue")
  },
  {
    name: "region-stats-Mvp___fr",
    path: "/fr/:region()/statistiques/mvp",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Mvp.vue")
  },
  {
    name: "region-stats-Mvp___it",
    path: "/it/:region()/statistiche/mvp",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Mvp.vue")
  },
  {
    name: "region-stats-Mvp___pt",
    path: "/pt/:region()/estatisticas/mvp",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Mvp.vue")
  },
  {
    name: "region-Regulation___ar",
    path: "/ar/:region()/regulation",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Regulation.vue")
  },
  {
    name: "region-Regulation___de",
    path: "/de/:region()/regeln",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Regulation.vue")
  },
  {
    name: "region-Regulation___en",
    path: "/en/:region()/regulation",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Regulation.vue")
  },
  {
    name: "region-Regulation___es",
    path: "/es/:region()/reglamento",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Regulation.vue")
  },
  {
    name: "region-Regulation___fr",
    path: "/fr/:region()/reglement",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Regulation.vue")
  },
  {
    name: "region-Regulation___it",
    path: "/it/:region()/regolamento",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Regulation.vue")
  },
  {
    name: "region-Regulation___pt",
    path: "/pt/:region()/regulamento",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/Regulation.vue")
  },
  {
    name: "region-TablesKwcc___ar",
    path: "/ar/:region()/tables-kwcc",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-nations","not-found-world-cup","not-found-queens","not-found-brazil","not-found-italy","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TablesKwcc.vue")
  },
  {
    name: "region-TablesKwcc___de",
    path: "/de/:region()/klassifikation-kwcc",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-nations","not-found-world-cup","not-found-queens","not-found-brazil","not-found-italy","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TablesKwcc.vue")
  },
  {
    name: "region-TablesKwcc___en",
    path: "/en/:region()/tables-kwcc",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-nations","not-found-world-cup","not-found-queens","not-found-brazil","not-found-italy","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TablesKwcc.vue")
  },
  {
    name: "region-TablesKwcc___es",
    path: "/es/:region()/clasificacion-kwcc",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-nations","not-found-world-cup","not-found-queens","not-found-brazil","not-found-italy","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TablesKwcc.vue")
  },
  {
    name: "region-TablesKwcc___fr",
    path: "/fr/:region()/classement-kwcc",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-nations","not-found-world-cup","not-found-queens","not-found-brazil","not-found-italy","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TablesKwcc.vue")
  },
  {
    name: "region-TablesKwcc___it",
    path: "/it/:region()/classifica-kwcc",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-nations","not-found-world-cup","not-found-queens","not-found-brazil","not-found-italy","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TablesKwcc.vue")
  },
  {
    name: "region-TablesKwcc___pt",
    path: "/pt/:region()/classificacao-kwcc",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-nations","not-found-world-cup","not-found-queens","not-found-brazil","not-found-italy","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TablesKwcc.vue")
  },
  {
    name: "region-Tournament___ar",
    path: "/ar/:region()/tournament",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tournament.vue")
  },
  {
    name: "region-Tournament___de",
    path: "/de/:region()/turnier",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tournament.vue")
  },
  {
    name: "region-Tournament___en",
    path: "/en/:region()/tournament",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tournament.vue")
  },
  {
    name: "region-Tournament___es",
    path: "/es/:region()/torneo",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tournament.vue")
  },
  {
    name: "region-Tournament___fr",
    path: "/fr/:region()/tournoi",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tournament.vue")
  },
  {
    name: "region-Tournament___it",
    path: "/it/:region()/torneo",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tournament.vue")
  },
  {
    name: "region-Tournament___pt",
    path: "/pt/:region()/campeonato",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/Tournament.vue")
  },
  {
    name: "region-stats-Cards___ar",
    path: "/ar/:region()/stats/cards",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Cards.vue")
  },
  {
    name: "region-stats-Cards___de",
    path: "/de/:region()/statistiken/karten",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Cards.vue")
  },
  {
    name: "region-stats-Cards___en",
    path: "/en/:region()/stats/cards",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Cards.vue")
  },
  {
    name: "region-stats-Cards___es",
    path: "/es/:region()/estadisticas/tarjetas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Cards.vue")
  },
  {
    name: "region-stats-Cards___fr",
    path: "/fr/:region()/statistiques/cartons",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Cards.vue")
  },
  {
    name: "region-stats-Cards___it",
    path: "/it/:region()/statistiche/cartellini",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Cards.vue")
  },
  {
    name: "region-stats-Cards___pt",
    path: "/pt/:region()/estatisticas/cartoes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Cards.vue")
  },
  {
    name: "region-stats-Goals___ar",
    path: "/ar/:region()/stats/goals",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goals.vue")
  },
  {
    name: "region-stats-Goals___de",
    path: "/de/:region()/statistiken/tore",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goals.vue")
  },
  {
    name: "region-stats-Goals___en",
    path: "/en/:region()/stats/goals",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goals.vue")
  },
  {
    name: "region-stats-Goals___es",
    path: "/es/:region()/estadisticas/goles",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goals.vue")
  },
  {
    name: "region-stats-Goals___fr",
    path: "/fr/:region()/statistiques/buts",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goals.vue")
  },
  {
    name: "region-stats-Goals___it",
    path: "/it/:region()/statistiche/gol",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goals.vue")
  },
  {
    name: "region-stats-Goals___pt",
    path: "/pt/:region()/estatisticas/gols",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goals.vue")
  },
  {
    name: "region-stats___ar",
    path: "/ar/:region()/stats",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/index.vue")
  },
  {
    name: "region-stats___de",
    path: "/de/:region()/statistiken",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/index.vue")
  },
  {
    name: "region-stats___en",
    path: "/en/:region()/stats",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/index.vue")
  },
  {
    name: "region-stats___es",
    path: "/es/:region()/estadisticas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/index.vue")
  },
  {
    name: "region-stats___fr",
    path: "/fr/:region()/statistiques",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/index.vue")
  },
  {
    name: "region-stats___it",
    path: "/it/:region()/statistiche",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/index.vue")
  },
  {
    name: "region-stats___pt",
    path: "/pt/:region()/estatisticas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/index.vue")
  },
  {
    name: "region-stats-Shots___ar",
    path: "/ar/:region()/stats/shots",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Shots.vue")
  },
  {
    name: "region-stats-Shots___de",
    path: "/de/:region()/statistiken/schusse",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Shots.vue")
  },
  {
    name: "region-stats-Shots___en",
    path: "/en/:region()/stats/shots",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Shots.vue")
  },
  {
    name: "region-stats-Shots___es",
    path: "/es/:region()/estadisticas/tiros",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Shots.vue")
  },
  {
    name: "region-stats-Shots___fr",
    path: "/fr/:region()/statistiques/tirs",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Shots.vue")
  },
  {
    name: "region-stats-Shots___it",
    path: "/it/:region()/statistiche/tiri",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Shots.vue")
  },
  {
    name: "region-stats-Shots___pt",
    path: "/pt/:region()/estatisticas/chutes-ao-gol",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Shots.vue")
  },
  {
    name: "region-news___ar",
    path: "/ar/:region()/:news()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/index.vue")
  },
  {
    name: "region-news___de",
    path: "/de/:region()/:news()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/index.vue")
  },
  {
    name: "region-news___en",
    path: "/en/:region()/:news()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/index.vue")
  },
  {
    name: "region-news___es",
    path: "/es/:region()/:news()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/index.vue")
  },
  {
    name: "region-news___fr",
    path: "/fr/:region()/:news()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/index.vue")
  },
  {
    name: "region-news___it",
    path: "/it/:region()/:news()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/index.vue")
  },
  {
    name: "region-news___pt",
    path: "/pt/:region()/:news()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/index.vue")
  },
  {
    name: "region-JoinTheDraft___ar",
    path: "/ar/:region()/join-the-draft",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/JoinTheDraft.vue")
  },
  {
    name: "region-JoinTheDraft___de",
    path: "/de/:region()/an-der-aufforderung-teilnehmen",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/JoinTheDraft.vue")
  },
  {
    name: "region-JoinTheDraft___en",
    path: "/en/:region()/join-the-draft",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/JoinTheDraft.vue")
  },
  {
    name: "region-JoinTheDraft___es",
    path: "/es/:region()/unete-al-draft",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/JoinTheDraft.vue")
  },
  {
    name: "region-JoinTheDraft___fr",
    path: "/fr/:region()/rejoindre-la-draft",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/JoinTheDraft.vue")
  },
  {
    name: "region-JoinTheDraft___it",
    path: "/it/:region()/join-the-draft",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/JoinTheDraft.vue")
  },
  {
    name: "region-JoinTheDraft___pt",
    path: "/pt/:region()/junte-se-ao-draft",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-queens","not-found-italy","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/JoinTheDraft.vue")
  },
  {
    name: "region-PlayersDraft___ar",
    path: "/ar/:region()/draft-players",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersDraft.vue")
  },
  {
    name: "region-PlayersDraft___de",
    path: "/de/:region()/draft-spieler",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersDraft.vue")
  },
  {
    name: "region-PlayersDraft___en",
    path: "/en/:region()/draft-players",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersDraft.vue")
  },
  {
    name: "region-PlayersDraft___es",
    path: "/es/:region()/jugadores-draft",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersDraft.vue")
  },
  {
    name: "region-PlayersDraft___fr",
    path: "/fr/:region()/joueurs-draft",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersDraft.vue")
  },
  {
    name: "region-PlayersDraft___it",
    path: "/it/:region()/giocatori-draft",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersDraft.vue")
  },
  {
    name: "region-PlayersDraft___pt",
    path: "/pt/:region()/jogadores-draft",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersDraft.vue")
  },
  {
    name: "region-news-post___ar",
    path: "/ar/:region()/:news()/:post()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/[post].vue")
  },
  {
    name: "region-news-post___de",
    path: "/de/:region()/:news()/:post()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/[post].vue")
  },
  {
    name: "region-news-post___en",
    path: "/en/:region()/:news()/:post()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/[post].vue")
  },
  {
    name: "region-news-post___es",
    path: "/es/:region()/:news()/:post()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/[post].vue")
  },
  {
    name: "region-news-post___fr",
    path: "/fr/:region()/:news()/:post()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/[post].vue")
  },
  {
    name: "region-news-post___it",
    path: "/it/:region()/:news()/:post()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/[post].vue")
  },
  {
    name: "region-news-post___pt",
    path: "/pt/:region()/:news()/:post()",
    meta: {"middleware":["validation-news-guard","not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/[news]/[post].vue")
  },
  {
    name: "region-DraftReserves___ar",
    path: "/ar/:region()/draft/reserves",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/DraftReserves.vue")
  },
  {
    name: "region-DraftReserves___de",
    path: "/de/:region()/draft/reservierungen",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/DraftReserves.vue")
  },
  {
    name: "region-DraftReserves___en",
    path: "/en/:region()/draft/reserves",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/DraftReserves.vue")
  },
  {
    name: "region-DraftReserves___es",
    path: "/es/:region()/draft/reservas",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/DraftReserves.vue")
  },
  {
    name: "region-DraftReserves___fr",
    path: "/fr/:region()/draft/reserves",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/DraftReserves.vue")
  },
  {
    name: "region-DraftReserves___it",
    path: "/it/:region()/draft/riserve",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/DraftReserves.vue")
  },
  {
    name: "region-DraftReserves___pt",
    path: "/pt/:region()/draft/reservas",
    meta: {"middleware":["not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/DraftReserves.vue")
  },
  {
    name: "region-PlayersLegend___ar",
    path: "/ar/:region()/legends",
    component: () => import("/usr/src/app/app/pages/[region]/PlayersLegend.vue")
  },
  {
    name: "region-PlayersLegend___de",
    path: "/de/:region()/legenden",
    component: () => import("/usr/src/app/app/pages/[region]/PlayersLegend.vue")
  },
  {
    name: "region-PlayersLegend___en",
    path: "/en/:region()/legends",
    component: () => import("/usr/src/app/app/pages/[region]/PlayersLegend.vue")
  },
  {
    name: "region-PlayersLegend___es",
    path: "/es/:region()/leyendas",
    component: () => import("/usr/src/app/app/pages/[region]/PlayersLegend.vue")
  },
  {
    name: "region-PlayersLegend___fr",
    path: "/fr/:region()/legendes",
    component: () => import("/usr/src/app/app/pages/[region]/PlayersLegend.vue")
  },
  {
    name: "region-PlayersLegend___it",
    path: "/it/:region()/leggende",
    component: () => import("/usr/src/app/app/pages/[region]/PlayersLegend.vue")
  },
  {
    name: "region-PlayersLegend___pt",
    path: "/pt/:region()/lendas",
    component: () => import("/usr/src/app/app/pages/[region]/PlayersLegend.vue")
  },
  {
    name: "region-stats-Assists___ar",
    path: "/ar/:region()/stats/assists",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Assists.vue")
  },
  {
    name: "region-stats-Assists___de",
    path: "/de/:region()/statistiken/vorlagen",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Assists.vue")
  },
  {
    name: "region-stats-Assists___en",
    path: "/en/:region()/stats/assists",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Assists.vue")
  },
  {
    name: "region-stats-Assists___es",
    path: "/es/:region()/estadisticas/asistencias",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Assists.vue")
  },
  {
    name: "region-stats-Assists___fr",
    path: "/fr/:region()/statistiques/passes-decisives",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Assists.vue")
  },
  {
    name: "region-stats-Assists___it",
    path: "/it/:region()/statistiche/assist",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Assists.vue")
  },
  {
    name: "region-stats-Assists___pt",
    path: "/pt/:region()/estatisticas/assistencias",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Assists.vue")
  },
  {
    name: "region-stats-Passing___ar",
    path: "/ar/:region()/stats/passing",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Passing.vue")
  },
  {
    name: "region-stats-Passing___de",
    path: "/de/:region()/statistiken/passe",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Passing.vue")
  },
  {
    name: "region-stats-Passing___en",
    path: "/en/:region()/stats/passing",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Passing.vue")
  },
  {
    name: "region-stats-Passing___es",
    path: "/es/:region()/estadisticas/pases",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Passing.vue")
  },
  {
    name: "region-stats-Passing___fr",
    path: "/fr/:region()/statistiques/passes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Passing.vue")
  },
  {
    name: "region-stats-Passing___it",
    path: "/it/:region()/statistiche/passaggi",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Passing.vue")
  },
  {
    name: "region-stats-Passing___pt",
    path: "/pt/:region()/estatisticas/passes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Passing.vue")
  },
  {
    name: "region-stats-TurnMvp___ar",
    path: "/ar/:region()/stats/matchday-mvp",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-nations","not-found-world-cup"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/TurnMvp.vue")
  },
  {
    name: "region-stats-TurnMvp___de",
    path: "/de/:region()/statistiken/mvp-spieltag",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-nations","not-found-world-cup"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/TurnMvp.vue")
  },
  {
    name: "region-stats-TurnMvp___en",
    path: "/en/:region()/stats/matchday-mvp",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-nations","not-found-world-cup"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/TurnMvp.vue")
  },
  {
    name: "region-stats-TurnMvp___es",
    path: "/es/:region()/estadisticas/mvp-jornada",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-nations","not-found-world-cup"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/TurnMvp.vue")
  },
  {
    name: "region-stats-TurnMvp___fr",
    path: "/fr/:region()/statistiques/mvp-du-jour",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-nations","not-found-world-cup"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/TurnMvp.vue")
  },
  {
    name: "region-stats-TurnMvp___it",
    path: "/it/:region()/statistiche/mvp-giornata",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-nations","not-found-world-cup"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/TurnMvp.vue")
  },
  {
    name: "region-stats-TurnMvp___pt",
    path: "/pt/:region()/estatisticas/mvp-rodada",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-nations","not-found-world-cup"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/TurnMvp.vue")
  },
  {
    name: "region-TeamSimulator___en",
    path: "/en/:region()/team-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-spain","not-found-world-cup","not-found-nations","not-found-queens","not-found-king-of-kings-nations","not-found-germany","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TeamSimulator.vue")
  },
  {
    name: "region-TeamSimulator___es",
    path: "/es/:region()/simulador-equipo",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-spain","not-found-world-cup","not-found-nations","not-found-queens","not-found-king-of-kings-nations","not-found-germany","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TeamSimulator.vue")
  },
  {
    name: "region-TeamSimulator___de",
    path: "/de/:region()/team-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-spain","not-found-world-cup","not-found-nations","not-found-queens","not-found-king-of-kings-nations","not-found-germany","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TeamSimulator.vue")
  },
  {
    name: "region-TeamSimulator___fr",
    path: "/fr/:region()/team-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-spain","not-found-world-cup","not-found-nations","not-found-queens","not-found-king-of-kings-nations","not-found-germany","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TeamSimulator.vue")
  },
  {
    name: "region-TeamSimulator___it",
    path: "/it/:region()/team-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-spain","not-found-world-cup","not-found-nations","not-found-queens","not-found-king-of-kings-nations","not-found-germany","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TeamSimulator.vue")
  },
  {
    name: "region-TeamSimulator___pt",
    path: "/pt/:region()/team-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-spain","not-found-world-cup","not-found-nations","not-found-queens","not-found-king-of-kings-nations","not-found-germany","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/TeamSimulator.vue")
  },
  {
    name: "region-SquadSimulator___en",
    path: "/en/:region()/squad-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/SquadSimulator.vue")
  },
  {
    name: "region-SquadSimulator___es",
    path: "/es/:region()/simulador-plantilla",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/SquadSimulator.vue")
  },
  {
    name: "region-SquadSimulator___de",
    path: "/de/:region()/squad-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/SquadSimulator.vue")
  },
  {
    name: "region-SquadSimulator___fr",
    path: "/fr/:region()/squad-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/SquadSimulator.vue")
  },
  {
    name: "region-SquadSimulator___it",
    path: "/it/:region()/squad-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/SquadSimulator.vue")
  },
  {
    name: "region-SquadSimulator___pt",
    path: "/pt/:region()/squad-simulator",
    meta: {"middleware":["not-found-italy","not-found-americas","not-found-world-cup","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/SquadSimulator.vue")
  },
  {
    name: "region-stats-Expected___ar",
    path: "/ar/:region()/stats/expected",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Expected.vue")
  },
  {
    name: "region-stats-Expected___de",
    path: "/de/:region()/statistiken/erwartete-tore",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Expected.vue")
  },
  {
    name: "region-stats-Expected___en",
    path: "/en/:region()/stats/expected",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Expected.vue")
  },
  {
    name: "region-stats-Expected___es",
    path: "/es/:region()/estadisticas/expected",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Expected.vue")
  },
  {
    name: "region-stats-Expected___fr",
    path: "/fr/:region()/statistiques/buts-attendus",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Expected.vue")
  },
  {
    name: "region-stats-Expected___it",
    path: "/it/:region()/statistiche/gol-previsti",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Expected.vue")
  },
  {
    name: "region-stats-Expected___pt",
    path: "/pt/:region()/estatisticas/gols-esperados",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Expected.vue")
  },
  {
    name: "teams-team-teamName___ar",
    path: "/ar/teams/:team()-:teamName()",
    meta: { ...(_91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/teams/[team]-[teamName].vue")
  },
  {
    name: "teams-team-teamName___de",
    path: "/de/mannschaften/:team()-:teamName()",
    meta: { ...(_91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/teams/[team]-[teamName].vue")
  },
  {
    name: "teams-team-teamName___en",
    path: "/en/teams/:team()-:teamName()",
    meta: { ...(_91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/teams/[team]-[teamName].vue")
  },
  {
    name: "teams-team-teamName___es",
    path: "/es/equipos/:team()-:teamName()",
    meta: { ...(_91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/teams/[team]-[teamName].vue")
  },
  {
    name: "teams-team-teamName___fr",
    path: "/fr/equipes/:team()-:teamName()",
    meta: { ...(_91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/teams/[team]-[teamName].vue")
  },
  {
    name: "teams-team-teamName___it",
    path: "/it/squadre/:team()-:teamName()",
    meta: { ...(_91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/teams/[team]-[teamName].vue")
  },
  {
    name: "teams-team-teamName___pt",
    path: "/pt/times/:team()-:teamName()",
    meta: { ...(_91team_93_45_91teamName_93kl17B8sqc4mnixg6NCuS5YiYMLdo7RkmfBwgHTmF2dEMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/teams/[team]-[teamName].vue")
  },
  {
    name: "region-PlayersVariable___ar",
    path: "/ar/:region()/wildcard-players",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersVariable.vue")
  },
  {
    name: "region-PlayersVariable___de",
    path: "/de/:region()/wildcard-spieler",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersVariable.vue")
  },
  {
    name: "region-PlayersVariable___en",
    path: "/en/:region()/wildcard-players",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersVariable.vue")
  },
  {
    name: "region-PlayersVariable___es",
    path: "/es/:region()/jugadores-wildcard",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersVariable.vue")
  },
  {
    name: "region-PlayersVariable___fr",
    path: "/fr/:region()/joueurs-wildcard",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersVariable.vue")
  },
  {
    name: "region-PlayersVariable___it",
    path: "/it/:region()/giocatori-wildcard",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersVariable.vue")
  },
  {
    name: "region-PlayersVariable___pt",
    path: "/pt/:region()/jogadores-wildcard",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/PlayersVariable.vue")
  },
  {
    name: "region-stats-Defensives___ar",
    path: "/ar/:region()/stats/defensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Defensives.vue")
  },
  {
    name: "region-stats-Defensives___de",
    path: "/de/:region()/statistiken/abwehrmassnahmen",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Defensives.vue")
  },
  {
    name: "region-stats-Defensives___en",
    path: "/en/:region()/stats/defensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Defensives.vue")
  },
  {
    name: "region-stats-Defensives___es",
    path: "/es/:region()/estadisticas/defensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Defensives.vue")
  },
  {
    name: "region-stats-Defensives___fr",
    path: "/fr/:region()/statistiques/defensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Defensives.vue")
  },
  {
    name: "region-stats-Defensives___it",
    path: "/it/:region()/statistiche/difensivo",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Defensives.vue")
  },
  {
    name: "region-stats-Defensives___pt",
    path: "/pt/:region()/estatisticas/defensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Defensives.vue")
  },
  {
    name: "region-stats-Goalkeeper___ar",
    path: "/ar/:region()/stats/goalkeeper",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue")
  },
  {
    name: "region-stats-Goalkeeper___de",
    path: "/de/:region()/statistiken/torwart",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue")
  },
  {
    name: "region-stats-Goalkeeper___en",
    path: "/en/:region()/stats/goalkeeper",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue")
  },
  {
    name: "region-stats-Goalkeeper___es",
    path: "/es/:region()/estadisticas/portero",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue")
  },
  {
    name: "region-stats-Goalkeeper___fr",
    path: "/fr/:region()/statistiques/gardien-de-but",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue")
  },
  {
    name: "region-stats-Goalkeeper___it",
    path: "/it/:region()/statistiche/portiere",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue")
  },
  {
    name: "region-stats-Goalkeeper___pt",
    path: "/pt/:region()/estatisticas/goleiro",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Goalkeeper.vue")
  },
  {
    name: "region-stats-Offensives___ar",
    path: "/ar/:region()/stats/offensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Offensives.vue")
  },
  {
    name: "region-stats-Offensives___de",
    path: "/de/:region()/statistiken/offensiven",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Offensives.vue")
  },
  {
    name: "region-stats-Offensives___en",
    path: "/en/:region()/stats/offensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Offensives.vue")
  },
  {
    name: "region-stats-Offensives___es",
    path: "/es/:region()/estadisticas/ofensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Offensives.vue")
  },
  {
    name: "region-stats-Offensives___fr",
    path: "/fr/:region()/statistiques/offensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Offensives.vue")
  },
  {
    name: "region-stats-Offensives___it",
    path: "/it/:region()/statistiche/offensivo",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Offensives.vue")
  },
  {
    name: "region-stats-Offensives___pt",
    path: "/pt/:region()/estatisticas/ofensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/Offensives.vue")
  },
  {
    name: "region-stats-teams-Cards___ar",
    path: "/ar/:region()/stats/teams/cards",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Cards.vue")
  },
  {
    name: "region-stats-teams-Cards___de",
    path: "/de/:region()/statistiken/mannschaften/karten",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Cards.vue")
  },
  {
    name: "region-stats-teams-Cards___en",
    path: "/en/:region()/stats/teams/cards",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Cards.vue")
  },
  {
    name: "region-stats-teams-Cards___es",
    path: "/es/:region()/estadisticas/equipos/tarjetas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Cards.vue")
  },
  {
    name: "region-stats-teams-Cards___fr",
    path: "/fr/:region()/statistiques/equipes/cartons",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Cards.vue")
  },
  {
    name: "region-stats-teams-Cards___it",
    path: "/it/:region()/statistiche/squadre/cartellini",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Cards.vue")
  },
  {
    name: "region-stats-teams-Cards___pt",
    path: "/pt/:region()/estatisticas/times/cartoes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Cards.vue")
  },
  {
    name: "region-stats-teams___ar",
    path: "/ar/:region()/stats/teams",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/index.vue")
  },
  {
    name: "region-stats-teams___de",
    path: "/de/:region()/statistiken/mannschaften",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/index.vue")
  },
  {
    name: "region-stats-teams___en",
    path: "/en/:region()/stats/teams",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/index.vue")
  },
  {
    name: "region-stats-teams___es",
    path: "/es/:region()/estadisticas/equipos",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/index.vue")
  },
  {
    name: "region-stats-teams___fr",
    path: "/fr/:region()/statistiques/equipes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/index.vue")
  },
  {
    name: "region-stats-teams___it",
    path: "/it/:region()/statistiche/squadre",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/index.vue")
  },
  {
    name: "region-stats-teams___pt",
    path: "/pt/:region()/estatisticas/times",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/index.vue")
  },
  {
    name: "region-stats-teams-Shots___ar",
    path: "/ar/:region()/stats/teams/shots",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Shots.vue")
  },
  {
    name: "region-stats-teams-Shots___de",
    path: "/de/:region()/statistiken/mannschaften/schusse",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Shots.vue")
  },
  {
    name: "region-stats-teams-Shots___en",
    path: "/en/:region()/stats/teams/shots",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Shots.vue")
  },
  {
    name: "region-stats-teams-Shots___es",
    path: "/es/:region()/estadisticas/equipos/tiros",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Shots.vue")
  },
  {
    name: "region-stats-teams-Shots___fr",
    path: "/fr/:region()/statistiques/equipes/tirs",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Shots.vue")
  },
  {
    name: "region-stats-teams-Shots___it",
    path: "/it/:region()/statistiche/squadre/tiri",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Shots.vue")
  },
  {
    name: "region-stats-teams-Shots___pt",
    path: "/pt/:region()/estatisticas/times/chutes-ao-gol",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Shots.vue")
  },
  {
    name: "region-stats-GoalsGrouped___ar",
    path: "/ar/:region()/stats/goals-grouped",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue")
  },
  {
    name: "region-stats-GoalsGrouped___de",
    path: "/de/:region()/statistiken/tore-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue")
  },
  {
    name: "region-stats-GoalsGrouped___en",
    path: "/en/:region()/stats/goals-grouped",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue")
  },
  {
    name: "region-stats-GoalsGrouped___es",
    path: "/es/:region()/estadisticas/goles-agrupado",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue")
  },
  {
    name: "region-stats-GoalsGrouped___fr",
    path: "/fr/:region()/statistiques/buts-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue")
  },
  {
    name: "region-stats-GoalsGrouped___it",
    path: "/it/:region()/statistiche/gol-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue")
  },
  {
    name: "region-stats-GoalsGrouped___pt",
    path: "/pt/:region()/estatisticas/gols-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/GoalsGrouped.vue")
  },
  {
    name: "region-stats-teams-Passing___ar",
    path: "/ar/:region()/stats/teams/passing",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Passing.vue")
  },
  {
    name: "region-stats-teams-Passing___de",
    path: "/de/:region()/statistiken/mannschaften/passe",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Passing.vue")
  },
  {
    name: "region-stats-teams-Passing___en",
    path: "/en/:region()/stats/teams/passing",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Passing.vue")
  },
  {
    name: "region-stats-teams-Passing___es",
    path: "/es/:region()/estadisticas/equipos/pases",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Passing.vue")
  },
  {
    name: "region-stats-teams-Passing___fr",
    path: "/fr/:region()/statistiques/equipes/passes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Passing.vue")
  },
  {
    name: "region-stats-teams-Passing___it",
    path: "/it/:region()/statistiche/squadre/passaggi",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Passing.vue")
  },
  {
    name: "region-stats-teams-Passing___pt",
    path: "/pt/:region()/estatisticas/times/passes",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Passing.vue")
  },
  {
    name: "region-stats-BestGoalkeeper___ar",
    path: "/ar/:region()/stats/best-goalkeeper",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue")
  },
  {
    name: "region-stats-BestGoalkeeper___de",
    path: "/de/:region()/statistiken/bester-torwart",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue")
  },
  {
    name: "region-stats-BestGoalkeeper___en",
    path: "/en/:region()/stats/best-goalkeeper",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue")
  },
  {
    name: "region-stats-BestGoalkeeper___es",
    path: "/es/:region()/estadisticas/mejor-portero",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue")
  },
  {
    name: "region-stats-BestGoalkeeper___fr",
    path: "/fr/:region()/statistiques/meilleur-gardien-de-but",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue")
  },
  {
    name: "region-stats-BestGoalkeeper___it",
    path: "/it/:region()/statistiche/miglior-portiere",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue")
  },
  {
    name: "region-stats-BestGoalkeeper___pt",
    path: "/pt/:region()/estatisticas/melhor-goleiro",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-italy","not-found-queens-americas","not-found-nations","not-found-king-of-kings-nations","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/BestGoalkeeper.vue")
  },
  {
    name: "region-stats-teams-Expected___ar",
    path: "/ar/:region()/stats/teams/expected",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Expected.vue")
  },
  {
    name: "region-stats-teams-Expected___de",
    path: "/de/:region()/statistiken/mannschaften/erwartete-tore",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Expected.vue")
  },
  {
    name: "region-stats-teams-Expected___en",
    path: "/en/:region()/stats/teams/expected",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Expected.vue")
  },
  {
    name: "region-stats-teams-Expected___es",
    path: "/es/:region()/estadisticas/equipos/expected",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Expected.vue")
  },
  {
    name: "region-stats-teams-Expected___fr",
    path: "/fr/:region()/statistiques/equipes/buts-attendus",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Expected.vue")
  },
  {
    name: "region-stats-teams-Expected___it",
    path: "/it/:region()/statistiche/squadre/gol-previsti",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Expected.vue")
  },
  {
    name: "region-stats-teams-Expected___pt",
    path: "/pt/:region()/estatisticas/times/gols-esperados",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Expected.vue")
  },
  {
    name: "region-circulars-CircularsEs___es",
    path: "/es/:region()/circulares",
    meta: {"middleware":["not-found-americas","not-found-spain","not-found-italy","not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/circulars/CircularsEs.vue")
  },
  {
    name: "region-circulars-CircularsIt___it",
    path: "/it/:region()/circolari",
    meta: {"middleware":["not-found-spain","not-found-king-of-kings-nations","not-found-brazil","not-found-americas","not-found-nations","not-found-world-cup","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/circulars/CircularsIt.vue")
  },
  {
    name: "region-MediaAccreditationInfo___ar",
    path: "/ar/:region()/media-accreditation",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue")
  },
  {
    name: "region-MediaAccreditationInfo___de",
    path: "/de/:region()/medien-akkreditierung",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue")
  },
  {
    name: "region-MediaAccreditationInfo___en",
    path: "/en/:region()/media-accreditation",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue")
  },
  {
    name: "region-MediaAccreditationInfo___es",
    path: "/es/:region()/acreditaciones-prensa",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue")
  },
  {
    name: "region-MediaAccreditationInfo___fr",
    path: "/fr/:region()/accreditation-presse",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue")
  },
  {
    name: "region-MediaAccreditationInfo___it",
    path: "/it/:region()/accrediti-media",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue")
  },
  {
    name: "region-MediaAccreditationInfo___pt",
    path: "/pt/:region()/acreditacao-media",
    meta: {"middleware":["not-found-king-of-kings-nations","not-found-brazil","not-found-nations","not-found-world-cup","not-found-france","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/MediaAccreditationInfo.vue")
  },
  {
    name: "region-stats-teams-Defensives___ar",
    path: "/ar/:region()/stats/teams/defensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue")
  },
  {
    name: "region-stats-teams-Defensives___de",
    path: "/de/:region()/statistiken/mannschaften/abwehrmassnahmen",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue")
  },
  {
    name: "region-stats-teams-Defensives___en",
    path: "/en/:region()/stats/teams/defensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue")
  },
  {
    name: "region-stats-teams-Defensives___es",
    path: "/es/:region()/estadisticas/equipos/defensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue")
  },
  {
    name: "region-stats-teams-Defensives___fr",
    path: "/fr/:region()/statistiques/equipes/defensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue")
  },
  {
    name: "region-stats-teams-Defensives___it",
    path: "/it/:region()/statistiche/squadre/difensivo",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue")
  },
  {
    name: "region-stats-teams-Defensives___pt",
    path: "/pt/:region()/estatisticas/times/defensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Defensives.vue")
  },
  {
    name: "region-stats-teams-Offensives___ar",
    path: "/ar/:region()/stats/teams/offensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue")
  },
  {
    name: "region-stats-teams-Offensives___de",
    path: "/de/:region()/statistiken/mannschaften/offensiven",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue")
  },
  {
    name: "region-stats-teams-Offensives___en",
    path: "/en/:region()/stats/teams/offensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue")
  },
  {
    name: "region-stats-teams-Offensives___es",
    path: "/es/:region()/estadisticas/equipos/ofensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue")
  },
  {
    name: "region-stats-teams-Offensives___fr",
    path: "/fr/:region()/statistiques/equipes/offensives",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue")
  },
  {
    name: "region-stats-teams-Offensives___it",
    path: "/it/:region()/statistiche/squadre/offensivo",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue")
  },
  {
    name: "region-stats-teams-Offensives___pt",
    path: "/pt/:region()/estatisticas/times/ofensivas",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/Offensives.vue")
  },
  {
    name: "players-playerId-playerName___ar",
    path: "/ar/players/:playerId()-:playerName()",
    meta: { ...(_91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/players/[playerId]-[playerName].vue")
  },
  {
    name: "players-playerId-playerName___de",
    path: "/de/spieler/:playerId()-:playerName()",
    meta: { ...(_91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/players/[playerId]-[playerName].vue")
  },
  {
    name: "players-playerId-playerName___en",
    path: "/en/players/:playerId()-:playerName()",
    meta: { ...(_91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/players/[playerId]-[playerName].vue")
  },
  {
    name: "players-playerId-playerName___es",
    path: "/es/jugadores/:playerId()-:playerName()",
    meta: { ...(_91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/players/[playerId]-[playerName].vue")
  },
  {
    name: "players-playerId-playerName___fr",
    path: "/fr/joueurs/:playerId()-:playerName()",
    meta: { ...(_91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/players/[playerId]-[playerName].vue")
  },
  {
    name: "players-playerId-playerName___it",
    path: "/it/giocatori/:playerId()-:playerName()",
    meta: { ...(_91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/players/[playerId]-[playerName].vue")
  },
  {
    name: "players-playerId-playerName___pt",
    path: "/pt/jogadores/:playerId()-:playerName()",
    meta: { ...(_91playerId_93_45_91playerName_93ZnUor8LWs9VaSf39wQd9bc08FeoV0L2eKXTx5nYZ00sMeta || {}), ...{"middleware":["not-found-king-of-kings-nations"]} },
    component: () => import("/usr/src/app/app/pages/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-teams-team-teamName___ar",
    path: "/ar/:region()/teams/:team()-:teamName()",
    component: () => import("/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue")
  },
  {
    name: "region-teams-team-teamName___de",
    path: "/de/:region()/mannschaften/:team()-:teamName()",
    component: () => import("/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue")
  },
  {
    name: "region-teams-team-teamName___en",
    path: "/en/:region()/teams/:team()-:teamName()",
    component: () => import("/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue")
  },
  {
    name: "region-teams-team-teamName___es",
    path: "/es/:region()/equipos/:team()-:teamName()",
    component: () => import("/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue")
  },
  {
    name: "region-teams-team-teamName___fr",
    path: "/fr/:region()/equipes/:team()-:teamName()",
    component: () => import("/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue")
  },
  {
    name: "region-teams-team-teamName___it",
    path: "/it/:region()/squadre/:team()-:teamName()",
    component: () => import("/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue")
  },
  {
    name: "region-teams-team-teamName___pt",
    path: "/pt/:region()/times/:team()-:teamName()",
    component: () => import("/usr/src/app/app/pages/[region]/teams/[team]-[teamName].vue")
  },
  {
    name: "region-stats-teams-GoalsGrouped___ar",
    path: "/ar/:region()/stats/teams/goals-grouped",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue")
  },
  {
    name: "region-stats-teams-GoalsGrouped___de",
    path: "/de/:region()/statistiken/mannschaften/tore-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue")
  },
  {
    name: "region-stats-teams-GoalsGrouped___en",
    path: "/en/:region()/stats/teams/goals-grouped",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue")
  },
  {
    name: "region-stats-teams-GoalsGrouped___es",
    path: "/es/:region()/estadisticas/equipos/goles-agrupado",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue")
  },
  {
    name: "region-stats-teams-GoalsGrouped___fr",
    path: "/fr/:region()/statistiques/equipes/buts-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue")
  },
  {
    name: "region-stats-teams-GoalsGrouped___it",
    path: "/it/:region()/statistiche/squadre/gol-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue")
  },
  {
    name: "region-stats-teams-GoalsGrouped___pt",
    path: "/pt/:region()/estatisticas/times/gols-a",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/stats/teams/GoalsGrouped.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersSpain___ar",
    path: "/ar/:region()/qualifiers/spain",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersSpain___de",
    path: "/de/:region()/qualifiers/spain",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersSpain___en",
    path: "/en/:region()/qualifiers/spain",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersSpain___es",
    path: "/es/:region()/qualifiers/spain",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersSpain___fr",
    path: "/fr/:region()/qualifiers/spain",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersSpain___it",
    path: "/it/:region()/qualifiers/spain",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersSpain___pt",
    path: "/pt/:region()/qualifiers/spain",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersSpain.vue")
  },
  {
    name: "region-players-playerId-playerName___ar",
    path: "/ar/:region()/players/:playerId()-:playerName()",
    component: () => import("/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-players-playerId-playerName___de",
    path: "/de/:region()/spieler/:playerId()-:playerName()",
    component: () => import("/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-players-playerId-playerName___en",
    path: "/en/:region()/players/:playerId()-:playerName()",
    component: () => import("/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-players-playerId-playerName___es",
    path: "/es/:region()/jugadores/:playerId()-:playerName()",
    component: () => import("/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-players-playerId-playerName___fr",
    path: "/fr/:region()/joueurs/:playerId()-:playerName()",
    component: () => import("/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-players-playerId-playerName___it",
    path: "/it/:region()/giocatori/:playerId()-:playerName()",
    component: () => import("/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-players-playerId-playerName___pt",
    path: "/pt/:region()/jogadores/:playerId()-:playerName()",
    component: () => import("/usr/src/app/app/pages/[region]/players/[playerId]-[playerName].vue")
  },
  {
    name: "region-qualifiers-KokQualifiersAmericas___ar",
    path: "/ar/:region()/qualifiers/americas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersAmericas___de",
    path: "/de/:region()/qualifiers/americas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersAmericas___en",
    path: "/en/:region()/qualifiers/americas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersAmericas___es",
    path: "/es/:region()/qualifiers/americas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersAmericas___fr",
    path: "/fr/:region()/qualifiers/americas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersAmericas___it",
    path: "/it/:region()/qualifiers/americas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue")
  },
  {
    name: "region-qualifiers-KokQualifiersAmericas___pt",
    path: "/pt/:region()/qualifiers/americas",
    meta: {"middleware":["not-found-americas","not-found-world-cup","not-found-spain","not-found-italy","not-found-nations","not-found-queens","not-found-brazil","not-found-france","not-found-germany","not-found-mena"]},
    component: () => import("/usr/src/app/app/pages/[region]/qualifiers/KokQualifiersAmericas.vue")
  },
  {
    name: "region-matches-matchId-homeTeam-vs-awayTeam___ar",
    path: "/ar/:region()/matches/:matchId()-:homeTeam()-vs-:awayTeam()",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue")
  },
  {
    name: "region-matches-matchId-homeTeam-vs-awayTeam___de",
    path: "/de/:region()/spiele/:matchId()-:homeTeam()-vs-:awayTeam()",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue")
  },
  {
    name: "region-matches-matchId-homeTeam-vs-awayTeam___en",
    path: "/en/:region()/matches/:matchId()-:homeTeam()-vs-:awayTeam()",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue")
  },
  {
    name: "region-matches-matchId-homeTeam-vs-awayTeam___es",
    path: "/es/:region()/partidos/:matchId()-:homeTeam()-vs-:awayTeam()",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue")
  },
  {
    name: "region-matches-matchId-homeTeam-vs-awayTeam___fr",
    path: "/fr/:region()/matchs/:matchId()-:homeTeam()-vs-:awayTeam()",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue")
  },
  {
    name: "region-matches-matchId-homeTeam-vs-awayTeam___it",
    path: "/it/:region()/partite/:matchId()-:homeTeam()-vs-:awayTeam()",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue")
  },
  {
    name: "region-matches-matchId-homeTeam-vs-awayTeam___pt",
    path: "/pt/:region()/jogos/:matchId()-:homeTeam()-vs-:awayTeam()",
    meta: {"middleware":["not-found-king-of-kings-nations"]},
    component: () => import("/usr/src/app/app/pages/[region]/matches/[matchId]-[homeTeam]-vs-[awayTeam].vue")
  }
]